<template>
    <div ref="outerStock" style="height: 400px"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data() {
            return {
                chart : null,
            }
        },
        props : ['data'],
        mounted () {
            this.createChart()
            // this.dummyData()
            this.generateData()
        },
        watch: {
            selected : function () {
                this.generateData()
            }
        },
        methods: {
            generateData() {
                let length = this.chart.data.length

				let data = this.data

				let key = Object.keys(this.data)

				let obj = []

				for(var i = 0 ; i < key.length ; i++) {
					let curObj = {
						name : this.toCapitalizedWords(key[i]),
						value : data[key[i]]
					}
					obj.push(curObj)
				}

                this.chart.addData(obj, length);
            },
            dummyData () {
                this.data = [
                    {manufacture_year:null, total:100},
                    {manufacture_year:2014, total:10},
                    {manufacture_year:2015, total:10},
                    {manufacture_year:2016, total:10},
                    {manufacture_year:2017, total:10},
                    {manufacture_year:2018, total:10},
                    {manufacture_year:2019, total:10},
                    {manufacture_year:2020, total:30}
                ]
                this.dealerData = [
                    {tahun:null, total:100},
                    {tahun:2014, total:10},
                    {tahun:2015, total:10},
                    {tahun:2016, total:10},
                    {tahun:2017, total:10},
                    {tahun:2018, total:10},
                    {tahun:2019, total:10},
                    {tahun:2020, total:30}
                ]
            },
            createChart() {
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.outerStock, am4charts.XYChart);

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "name";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 30;

                // categoryAxis.renderer.labels.template.adapter.add("dy", function (dy, target) {
                //     if (target.dataItem && target.dataItem.index & 2 == 2) {
                //         return dy + 25;
                //     }
                //     return dy;
                // });

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;

                // Create series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "value";
                series.dataFields.categoryX = "name";
                series.name = "Jumlah Stock";
                series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                series.columns.template.fillOpacity = .8;

                let columnTemplate = series.columns.template;
                columnTemplate.strokeWidth = 2;
                columnTemplate.strokeOpacity = 1;

            }
        }
    }
</script>

<style scoped>

</style>